<template>
    <div>
        <b>{{ $t('sideBarSettings.phenoPhase') }}</b>
        <select v-model="selectedPhenoPhase" class="custom-select">
            <option
                v-for="(phenoPhase, index) in phenoPhasesFiltered"
                :key="index"
                :value="phenoPhase.phase">
                {{ $t(`phenoPhases.${phenoPhase.phase}`) }} (bbch: {{phenoPhase.bbch}})
            </option>
        </select>
        <img :src="imgSrc" style="width:130px;height:auto;margin-top:10px;">
    </div>
</template>
<script>


export default {
    components:{
    },

    props:{
        leftSide:Boolean
    },

    async mounted() {
        try{
            this.bbchArray = await fetch('/bbch.json')
                .then(response => response.json())
                .then(files => {return files})
        } catch(e){
            console.error('geojson error',e)
        }

        if (this.leftSide)
            this.selectedPhenoPhase = this.$store.state.selectedPhenoPhaseG;
        else
            this.selectedPhenoPhase = this.$store.state.selectedPhenoPhaseD;
        
    },
    
    data() {
        return {
            selectedPhenoPhase: null,
            bbchArray:[]
        }
    },

    computed:{
        settings(){
            return this.$store.state.settings
        },
        parcels(){
            return this.$store.state.parcels
        },
        imgSrc(){
            if (!this.selectedActuator) return null
            return "images/" + this.selectedPhenoPhase.toLowerCase() + ".png"
        },
        selectedParcelNameD(){
            return this.$store.state.selectedParcelNameD
        },
        selectedParcelNameG(){
            return this.$store.state.selectedParcelNameG
        },
        parcelsPhases(){
            // object with all phenophases for each parcel
            return this.settings.parcelNames.reduce((acc, name) => {
                acc[name] = this.parcels
                    .filter(p => p.parcelName === name)
                    .map(p => p.phenoPhase);
                return acc;
            }, {});
        },
        
        phenoPhasesFiltered(){
            let parcelName = null
            if (this.leftSide) parcelName = this.selectedParcelNameG
            else parcelName = this.selectedParcelNameD
            const parcelBbch = this.getParcelsBbch(parcelName).filter(e => this.getParcelStages(parcelName).includes(e.stage))
                                
            return this.parcelsPhases[parcelName].map(p=>{
                return {
                    phase: p,
                    bbch : parcelBbch.find(pb=> pb.stage === p.split('-')[0]).value,
                }
            })
            
        },  
        
    },

    methods: {
        getParcelStages(parcelName){
            // t1, t2 etc...
            return this.parcelsPhases[parcelName].map(p => p.split('-')[0])
        },
        getParcelsBbch(parcelName){
            return this.bbchArray.filter(e => e.block === parcelName)
                                
        }
    },

    watch: {
        selectedPhenoPhase(val){
            if (this.leftSide)
                this.$store.commit("setSelectedPhenoPhaseG", val);
            else
                this.$store.commit("setSelectedPhenoPhaseD", val);
        }
    },
}
</script>

<style scoped>
.global{height: auto;}
p{background-color: black;color: blanchedalmond;}
img{max-width: 300px;max-height: 300px;}
#iconedebut{width: 100%;height: 100%;}
#iconemilieu{width: 100%;height: 100%;}
#iconefin{width: 100%;height: 100%;}
#btndebut{grid-area: btndb;width: auto;height: auto;margin: 40px;}
#btnmilieu{grid-area: btnml;width: auto;height: auto;margin: 40px;}
#btnfin{grid-area: btnfn;width: auto;height: auto;margin: 40px;}

</style>

